// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"bf6a7cf3","835":"3d691f5f"}[chunkId] + ".chunk.js";
};